import { jsx as e } from "react/jsx-runtime";
import l from "./styles.module.less.js";
import { MobileMenu as c } from "./mobile.js";
import { DesktopMenu as N } from "./desktop.js";
import { DEFAULT_LANGUAGE_CODE as A } from "../../../constants.js";
import { useScreenSize as E, WidthType as d } from "../../../utils/use-is-mobile.js";
const h = "FLOATING_CONTAINER_ID", M = "MENU_HEADER_ID", C = (p) => {
  const {
    isAuthenticated: t,
    openAuthModal: n,
    userImage: r,
    logout: i,
    hasNotifications: s,
    language: o = A,
    getTranslation: a,
    isLawyerSupported: m
  } = p, u = E();
  return console.log("language", o), u === d.Mobile ? /* @__PURE__ */ e("div", { className: l.mobileMenuWrapper, children: /* @__PURE__ */ e(
    c,
    {
      isAuthenticated: t,
      openAuthModal: n,
      userImage: r,
      logout: i,
      hasNotifications: s,
      language: o,
      getTranslation: a,
      isLawyerSupported: m
    }
  ) }) : /* @__PURE__ */ e("div", { className: l.desktopMenuContainer, id: M, children: /* @__PURE__ */ e(
    N,
    {
      isAuthenticated: t,
      openAuthModal: n,
      userImage: r,
      logout: i,
      hasNotifications: s,
      language: o,
      getTranslation: a,
      isLawyerSupported: m
    }
  ) });
};
export {
  h as FLOATING_CONTAINER_ID,
  M as MENU_HEADER_ID,
  C as MenuComponent
};
